import React, { useEffect, useRef, useState } from "react";
import { Bookmark, Share2, Search, X, TrendingUp, Calendar, ExternalLink, ChevronDown } from "lucide-react";
import { getNews, searchStockName } from "../../../api/api";
import { Box, Typography, Button, IconButton } from "@mui/material";

/* ---------------- time helper ---------------- */
const getTimeAgo = (publishedAt) => {
    const published = new Date(publishedAt.endsWith('Z') ? publishedAt : publishedAt + 'Z');
    const diffMin = Math.floor((Date.now() - published) / 60000);

    if (diffMin < 1) return "Just now";
    if (diffMin < 60) return `${diffMin}m ago`;

    const hours = Math.floor(diffMin / 60);
    if (hours < 24) return `${hours}h ago`;

    const days = Math.floor(hours / 24);
    if (days === 1) return "Yesterday";
    if (days < 7) return `${days}d ago`;

    return published.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};
/* ---------------- News Row ---------------- */
const NewsRow = ({ item, isLast }) => {
    const [saved, setSaved] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [isTitleHovered, setIsTitleHovered] = useState(false);

    return (
        <div>
            <div
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{
                    display: 'flex',
                    gap: 'var(--spacing-md)',
                    padding: 'var(--spacing-md) var(--spacing-sm)',
                    borderRadius: 'var(--radius-md)',
                    backgroundColor: isHovered ? 'var(--color-surface-hover)' : 'transparent',
                    transition: 'background-color var(--transition-fast)',
                }}
            >
                {/* Image */}
                <div
                    style={{
                        width: '96px',
                        height: '96px',
                        borderRadius: 'var(--radius-lg)',
                        backgroundColor: 'var(--color-bg-secondary)',
                        flexShrink: 0,
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {item.image_url ? (
                        <img src={item.image_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    ) : (
                        <TrendingUp size={32} color="var(--color-border-secondary)" />
                    )}
                </div>

                {/* Content */}
                <div style={{ flex: 1, minWidth: 0 }}>
                    {/* Source & Time */}
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 'var(--spacing-sm)',
                            marginBottom: 'var(--spacing-xs)',
                            flexWrap: 'wrap',
                        }}
                    >
                        {/* Source */}
                        <Typography
                            variant="paragraph"
                            sx={{
                                // fontSize: 'var(--font-size-base)',
                                fontWeight: 'var(--font-weight-bold)',
                                color: 'var(--color-primary)',
                            }}
                        >
                            {item.source}
                        </Typography>

                        <span
                            style={{
                                width: '4px',
                                height: '4px',
                                borderRadius: '50%',
                                backgroundColor: 'var(--color-border-secondary)',
                                flexShrink: 0,
                            }}
                        />

                        {/* Time */}
                        <span style={{ display: 'flex', alignItems: 'center', gap: 'var(--spacing-xs)' }}>
                            <Calendar size={12} color="var(--color-text-muted)" />
                            <Typography
                                variant="paragraph"
                                sx={{
                                    // fontSize: 'var(--font-size-base)',
                                    color: 'var(--color-text-muted)',
                                }}
                            >
                                {getTimeAgo(item.created_at)}
                            </Typography>
                        </span>
                    </div>

                    {/* Title */}
                    <Typography
                        variant="paragraph"
                        onClick={() => window.open(item.url, "_blank", "noopener,noreferrer")}
                        onMouseEnter={() => setIsTitleHovered(true)}
                        onMouseLeave={() => setIsTitleHovered(false)}
                        sx={{
                            fontWeight: 'var(--font-weight-semibold)',
                            mb: 'var(--spacing-sm)',
                            cursor: 'pointer',
                            color: isTitleHovered ? 'var(--color-primary)' : 'var(--color-text-primary)',
                            transition: 'color var(--transition-fast)',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                        }}
                    >
                        {item.title}
                    </Typography>

                    {/* Actions */}
                    <div style={{ display: 'flex', gap: 'var(--spacing-md)', alignItems: 'center' }}>
                        {/* <Button
                            size="small"
                            onClick={() => setSaved(!saved)}
                            startIcon={<Bookmark size={14} fill={saved ? "currentColor" : "none"} />}
                            sx={{
                                minWidth: 'auto',
                                p: 0,
                                fontSize: 'var(--font-size-base)',
                                fontWeight: 'var(--font-weight-medium)',
                                color: saved ? 'var(--color-primary)' : 'var(--color-text-muted)',
                                textTransform: 'none',
                                '&:hover': { backgroundColor: 'transparent', color: 'var(--color-primary)' },
                            }}
                        >
                            {saved ? 'Saved' : 'Save'}
                        </Button>

                        <Button
                            size="small"
                            startIcon={<Share2 size={14} />}
                            sx={{
                                minWidth: 'auto',
                                p: 0,
                                fontSize: 'var(--font-size-base)',
                                fontWeight: 'var(--font-weight-medium)',
                                color: 'var(--color-text-muted)',
                                textTransform: 'none',
                                '&:hover': { backgroundColor: 'transparent', color: 'var(--color-primary)' },
                            }}
                        >
                            Share
                        </Button> */}

                        <Button
                            size="small"
                            onClick={() => window.open(item.url, "_blank", "noopener,noreferrer")}
                            startIcon={<ExternalLink size={14} />}
                            sx={{
                                minWidth: 'auto',
                                p: 0,
                                fontSize: 'var(--font-size-base)',
                                fontWeight: 'var(--font-weight-medium)',
                                color: 'var(--color-text-muted)',
                                textTransform: 'none',
                                '&:hover': { backgroundColor: 'transparent', color: 'var(--color-primary)' },
                            }}
                        >
                            Read
                        </Button>
                    </div>
                </div>
            </div>

            {!isLast && (
                <div style={{ borderBottom: '1px solid var(--color-border-primary)' }} />
            )}
        </div>
    );
};

/* ---------------- Loading Skeleton ---------------- */
const NewsRowSkeleton = () => (
    <div
        style={{
            display: 'flex',
            gap: 'var(--spacing-md)',
            padding: 'var(--spacing-md) 0',
            animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
        }}
    >
        <div
            style={{
                width: '96px',
                height: '96px',
                borderRadius: 'var(--radius-lg)',
                backgroundColor: 'var(--color-bg-tertiary)',
                flexShrink: 0,
            }}
        />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 'var(--spacing-xs)' }}>
            <div style={{ height: '12px', width: '96px', backgroundColor: 'var(--color-bg-tertiary)', borderRadius: 'var(--radius-sm)' }} />
            <div style={{ height: '16px', width: '100%', backgroundColor: 'var(--color-bg-tertiary)', borderRadius: 'var(--radius-sm)' }} />
            <div style={{ height: '16px', width: '75%', backgroundColor: 'var(--color-bg-tertiary)', borderRadius: 'var(--radius-sm)' }} />
            <div style={{ height: '12px', width: '128px', backgroundColor: 'var(--color-bg-tertiary)', borderRadius: 'var(--radius-sm)', marginTop: 'var(--spacing-xs)' }} />
        </div>
    </div>
);

/* ================== MAIN ================== */
const News = () => {
    const [news, setNews] = useState([]);
    const [ticker, setTicker] = useState(null);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [fetchError, setFetchError] = useState(false);
    const isSelectingRef = useRef(false);

    /* ticker search */
    const [searchValue, setSearchValue] = useState("");
    const [results, setResults] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [pageSizeOpen, setPageSizeOpen] = useState(false);
    const searchRef = useRef(null);
    const pageSizeRef = useRef(null);

    const fetchNews = async (selectedTicker = null, selectedPage = 1) => {
        setLoading(true);
        setNews([]);
        setFetchError(false);

        const res = await getNews(selectedTicker, selectedPage, pageSize);

        if (res?.success) {
            setNews(res.data?.items || []);
            setHasMore(res.data?.has_more ?? false);
        } else {
            setNews([]);
            setFetchError(true);
        }

        setLoading(false);
    };

    useEffect(() => {
        fetchNews(null, 1);
    }, []);

    useEffect(() => {
        if (isSelectingRef.current) {
            isSelectingRef.current = false;
            setDropdownOpen(false);
            return;
        }

        if (!searchValue.trim()) {
            setResults([]);
            setDropdownOpen(false);
            return;
        }

        setSearchLoading(true);

        const delay = setTimeout(async () => {
            const res = await searchStockName(searchValue.trim());
            if (res?.success) {
                setResults(res.data || []);
                setDropdownOpen(true);
            } else {
                setResults([]);
                setDropdownOpen(false);
            }
            setSearchLoading(false);
        }, 300);

        return () => clearTimeout(delay);
    }, [searchValue]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) setDropdownOpen(false);
            if (pageSizeRef.current && !pageSizeRef.current.contains(event.target)) setPageSizeOpen(false);
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSearchSubmit = async () => {
        if (!searchValue.trim()) return;
        const newTicker = searchValue.trim().toUpperCase();
        setPage(1);
        setTicker(newTicker);
        await fetchNews(newTicker, 1);
    };

    const handleTickerSelect = async (selectedTicker) => {
        const newTicker = selectedTicker.ticker.toUpperCase();
        isSelectingRef.current = true;
        setDropdownOpen(false);
        setResults([]);
        setSearchLoading(false);
        setSearchValue(newTicker);
        setTicker(newTicker);
        setPage(1);
        await fetchNews(newTicker, 1);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleSearchSubmit();
    };

    const handleClearFilter = async () => {
        setTicker(null);
        setSearchValue("");
        setPage(1);
        await fetchNews(null, 1);
    };

    useEffect(() => {
        setPage(1);
        fetchNews(ticker, 1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageSize]);

    return (
        <Box
            sx={{
                minHeight: '100vh',
                backgroundColor: 'var(--color-bg-primary)',
                p: 'var(--spacing-xl)',
            }}
        >
            {/* ── Header ── */}
            <Box
                sx={{
                    mb: 'var(--spacing-lg)',
                    // mt: 'var(--spacing-xl)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 'var(--spacing-xs)',
                }}
            >
                <Typography variant="title">
                    Market News
                </Typography>

                <Typography
                    variant="paragraph"
                    sx={{ color: 'var(--color-text-muted)' }}
                >
                    Stay updated with the latest financial news and market insights
                </Typography>
            </Box>

            {/* ── Controls ── */}
            <div
                style={{
                    backgroundColor: 'var(--color-surface)',
                    border: '1px solid var(--color-border-primary)',
                    borderRadius: 'var(--radius-xl)',
                    padding: 'var(--spacing-md)',
                    marginBottom: 'var(--spacing-md)',
                }}
            >
                <div style={{ display: 'flex', gap: 'var(--spacing-sm)', flexWrap: 'wrap', alignItems: 'center' }}>

                    {/* Ticker Search */}
                    <div style={{ flex: 1, minWidth: '280px', display: 'flex', gap: 'var(--spacing-sm)' }}>
                        <div ref={searchRef} style={{ position: 'relative', flex: 1 }}>
                            <Search
                                size={18}
                                style={{
                                    position: 'absolute',
                                    left: '0.75rem',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    color: 'var(--color-text-muted)',
                                    pointerEvents: 'none',
                                }}
                            />
                            <input
                                type="text"
                                placeholder="Search by ticker or company..."
                                value={searchValue}
                                onChange={(e) => setSearchValue(e.target.value)}
                                onKeyDown={handleKeyDown}
                                style={{
                                    width: '100%',
                                    paddingLeft: '2.5rem',
                                    paddingRight: '2.5rem',
                                    paddingTop: '0.625rem',
                                    paddingBottom: '0.625rem',
                                    backgroundColor: 'var(--color-bg-secondary)',
                                    border: '1px solid var(--color-border-primary)',
                                    borderRadius: 'var(--radius-md)',
                                    color: 'var(--color-text-primary)',
                                    fontSize: 'var(--font-size-sm)',
                                    fontWeight: 'var(--font-weight-medium)',
                                    outline: 'revert',
                                    transition: 'all var(--transition-fast)',
                                    fontFamily: 'inherit',
                                    boxSizing: 'border-box',
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = 'var(--color-primary)';
                                    e.target.style.boxShadow = '0 0 0 3px var(--color-primary-lighter)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = 'var(--color-border-primary)';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />

                            {searchValue && (
                                <div style={{ position: 'absolute', right: '0.75rem', top: '50%', transform: 'translateY(-50%)' }}>
                                    {searchLoading ? (
                                        <div
                                            style={{
                                                width: '16px',
                                                height: '16px',
                                                border: '2px solid var(--color-primary)',
                                                borderTopColor: 'transparent',
                                                borderRadius: '50%',
                                                animation: 'spin 0.8s linear infinite',
                                            }}
                                        />
                                    ) : (
                                        <IconButton
                                            size="small"
                                            onClick={async () => {
                                                setSearchValue("");
                                                setDropdownOpen(false);
                                                if (ticker) {
                                                    setTicker(null);
                                                    setPage(1);
                                                    await fetchNews(null, 1);
                                                }
                                            }}
                                            sx={{ p: 0, color: 'var(--color-text-muted)', '&:hover': { color: 'var(--color-text-primary)' } }}
                                        >
                                            <X size={16} />
                                        </IconButton>
                                    )}
                                </div>
                            )}

                            {/* Dropdown */}
                            {dropdownOpen && results.length > 0 && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        right: 0,
                                        marginTop: 'var(--spacing-xs)',
                                        backgroundColor: 'var(--color-surface)',
                                        border: '1px solid var(--color-border-primary)',
                                        borderRadius: 'var(--radius-md)',
                                        boxShadow: 'var(--shadow-lg)',
                                        maxHeight: '288px',
                                        overflowY: 'auto',
                                        zIndex: 50,
                                    }}
                                >
                                    {results.map((item, index) => (
                                        <div
                                            key={item.ticker}
                                            onClick={() => handleTickerSelect(item)}
                                            style={{
                                                padding: 'var(--spacing-sm) var(--spacing-md)',
                                                cursor: 'pointer',
                                                borderBottom: index < results.length - 1 ? '1px solid var(--color-border-primary)' : 'none',
                                                transition: 'background-color var(--transition-fast)',
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--color-surface-hover)'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                                        >
                                            <Typography
                                                variant="paragraph"
                                                sx={{
                                                    fontWeight: 'var(--font-weight-semibold)',
                                                    fontSize: 'var(--font-size-sm)',
                                                    color: 'var(--color-text-primary)',
                                                }}
                                            >
                                                {item.ticker}
                                            </Typography>
                                            <Typography
                                                variant="paragraph"
                                                sx={{
                                                    fontSize: 'var(--font-size-base)',
                                                    color: 'var(--color-text-muted)',
                                                    ml: 2
                                                }}
                                            >
                                                {item.company_name}
                                            </Typography>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <Button
                            variant="contained"
                            onClick={handleSearchSubmit}
                            disabled={!searchValue.trim()}
                            startIcon={<Search size={16} />}
                            sx={{
                                fontSize: 'var(--font-size-sm)',
                                fontWeight: 'var(--font-weight-semibold)',
                                bgcolor: searchValue.trim() ? 'var(--color-primary)' : 'var(--color-surface-active)',
                                color: searchValue.trim() ? 'var(--color-text-inverse)' : 'var(--color-text-muted)',
                                '&:hover': {
                                    bgcolor: searchValue.trim() ? 'var(--color-primary-dark)' : 'var(--color-surface-active)',
                                },
                                '&.Mui-disabled': {
                                    bgcolor: 'var(--color-surface-active)',
                                    color: 'var(--color-text-muted)',
                                },
                            }}
                        >
                            Search
                        </Button>
                    </div>

                    {/* Page Size Dropdown */}
                    <div ref={pageSizeRef} style={{ position: 'relative' }}>
                        <Button
                            onClick={() => setPageSizeOpen(!pageSizeOpen)}
                            endIcon={<ChevronDown size={16} />}
                            sx={{
                                fontSize: 'var(--font-size-sm)',
                                fontWeight: 'var(--font-weight-medium)',
                                backgroundColor: 'var(--color-bg-secondary)',
                                border: '1px solid var(--color-border-primary)',
                                minWidth: '140px',
                                color: 'var(--color-text-primary)',
                                textTransform: 'none',
                                '&:hover': { backgroundColor: 'var(--color-surface-hover)' },
                            }}
                        >
                            {pageSize} per page
                        </Button>

                        {pageSizeOpen && (
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '100%',
                                    right: 0,
                                    marginTop: 'var(--spacing-xs)',
                                    backgroundColor: 'var(--color-surface)',
                                    border: '1px solid var(--color-border-primary)',
                                    borderRadius: 'var(--radius-md)',
                                    boxShadow: 'var(--shadow-lg)',
                                    zIndex: 50,
                                    minWidth: '140px',
                                    overflow: 'hidden',
                                }}
                            >
                                {[5, 10, 20, 50].map((n) => (
                                    <div
                                        key={n}
                                        onClick={() => {
                                            setPageSize(n);
                                            // setPage(1);
                                            setPageSizeOpen(false);
                                        }}
                                        style={{
                                            padding: 'var(--spacing-sm) var(--spacing-md)',
                                            cursor: 'pointer',
                                            fontSize: 'var(--font-size-sm)',
                                            fontWeight: pageSize === n ? 'var(--font-weight-semibold)' : 'var(--font-weight-normal)',
                                            backgroundColor: pageSize === n ? 'var(--color-primary-lighter)' : 'transparent',
                                            color: pageSize === n ? 'var(--color-primary)' : 'var(--color-text-primary)',
                                            transition: 'background-color var(--transition-fast)',
                                        }}
                                        onMouseEnter={(e) => {
                                            if (pageSize !== n) e.currentTarget.style.backgroundColor = 'var(--color-surface-hover)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = pageSize === n ? 'var(--color-primary-lighter)' : 'transparent';
                                        }}
                                    >
                                        {n} items
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Active Filter Chip */}
                {ticker && (
                    <div
                        style={{
                            marginTop: 'var(--spacing-md)',
                            paddingTop: 'var(--spacing-md)',
                            borderTop: '1px solid var(--color-border-primary)',
                        }}
                    >
                        <span
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 'var(--spacing-sm)',
                                padding: '6px var(--spacing-md)',
                                backgroundColor: 'var(--color-primary-lighter)',
                                color: 'var(--color-primary)',
                                borderRadius: 'var(--radius-full)',
                            }}
                        >
                            <Typography
                                variant="paragraph"
                                sx={{
                                    fontSize: 'var(--font-size-sm)',
                                    fontWeight: 'var(--font-weight-medium)',
                                    color: 'var(--color-primary)',
                                }}
                            >
                                Filtered by: {ticker}
                            </Typography>
                            <IconButton
                                size="small"
                                onClick={handleClearFilter}
                                sx={{
                                    p: '2px',
                                    color: 'var(--color-primary)',
                                    '&:hover': { backgroundColor: 'rgba(0,150,255,0.15)' },
                                }}
                            >
                                <X size={14} />
                            </IconButton>
                        </span>
                    </div>
                )}
            </div>

            {/* ── News List ── */}
            <div
                style={{
                    backgroundColor: 'var(--color-surface)',
                    border: '1px solid var(--color-border-primary)',
                    borderRadius: 'var(--radius-xl)',
                    padding: 'var(--spacing-xl)',
                    minHeight: '500px',
                }}
            >
                {loading ? (
                    <div>
                        {Array.from({ length: 5 }).map((_, i) => (
                            <NewsRowSkeleton key={`skeleton-${i}`} />
                        ))}
                    </div>
                ) : news.length === 0 ? (
                    <div style={{ padding: 'var(--spacing-2xl) 0', textAlign: 'center', flexDirection: "column" }}>
                        <TrendingUp
                            size={56}
                            color="var(--color-border-secondary)"
                            style={{ margin: '0 auto var(--spacing-md)' }}
                        />
                        <Box display="flex" flexDirection="column">
                            <Typography
                                variant="subtitle"
                                sx={{ color: 'var(--color-text-primary)', mb: 'var(--spacing-sm)' }}
                            >
                                {fetchError ? "News temporarily unavailable" : "No news found"}
                            </Typography>
                            <Typography
                                variant="paragraph"
                                sx={{ color: 'var(--color-text-muted)' }}
                            >
                                {fetchError
                                    ? "We're having trouble loading news right now. Please try again later."
                                    : ticker
                                        ? `No news available for ${ticker} at the moment`
                                        : "Try adjusting your filters or check back later"}
                            </Typography>
                        </Box>
                    </div>
                ) : (
                    <div>
                        {news.map((item, index) => (
                            <NewsRow
                                key={`${item.url}-${item.created_at}-${index}`}
                                item={item}
                                isLast={index === news.length - 1}
                            />
                        ))}
                    </div>
                )}

                {/* Pagination */}
                {news.length > 0 && (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: 'var(--spacing-lg)',
                            paddingTop: 'var(--spacing-lg)',
                            borderTop: '1px solid var(--color-border-primary)',
                        }}
                    >
                        <Button
                            disabled={page === 1}
                            onClick={async () => {
                                const newPage = page - 1;
                                setPage(newPage);
                                await fetchNews(ticker, newPage);
                            }}
                            sx={{
                                fontSize: 'var(--font-size-sm)',
                                fontWeight: 'var(--font-weight-medium)',
                                backgroundColor: 'var(--color-bg-secondary)',
                                border: '1px solid var(--color-border-primary)',
                                color: 'var(--color-text-primary)',
                                textTransform: 'none',
                                '&:hover': { backgroundColor: 'var(--color-surface-hover)' },
                                '&.Mui-disabled': { opacity: 0.5 },
                            }}
                        >
                            Previous
                        </Button>

                        <Typography
                            variant="tableHeader"
                            sx={{ color: 'var(--color-text-secondary)' }}
                        >
                            Page {page}
                        </Typography>

                        <Button
                            disabled={!hasMore}
                            onClick={async () => {
                                const newPage = page + 1;
                                setPage(newPage);
                                await fetchNews(ticker, newPage);
                            }}
                            sx={{
                                fontSize: 'var(--font-size-sm)',
                                fontWeight: 'var(--font-weight-medium)',
                                backgroundColor: 'var(--color-bg-secondary)',
                                border: '1px solid var(--color-border-primary)',
                                color: 'var(--color-text-primary)',
                                textTransform: 'none',
                                '&:hover': { backgroundColor: 'var(--color-surface-hover)' },
                                '&.Mui-disabled': { opacity: 0.5 },
                            }}
                        >
                            Next
                        </Button>
                    </div>
                )}
            </div>

            <style>{`
                @keyframes pulse {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.5; }
                }
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </Box>
    );
};

export default News;